import { api } from "./api";

/* blogApi — admin client for blog posts CRUD. */

const BASE = "/blog";

function toUi(p) {
  if (!p) return null;
  return {
    id: p.id,
    slug: p.slug,
    title: p.title,
    excerpt: p.excerpt || "",
    body: p.body || "",
    heroImageUrl: p.heroImageUrl || "",
    author: p.author || "Abhi Ghar Team",
    authorId: p.authorId || null,
    tags: Array.isArray(p.tags) ? p.tags : [],
    status: p.status,
    featured: !!p.featured,
    readingTime: p.readingTime || 3,
    viewCount: p.viewCount || 0,
    sortOrder: p.sortOrder || 0,
    isDemo: !!p.isDemo,
    publishedAt: p.publishedAt,
    createdAt: p.createdAt,
    updatedAt: p.updatedAt,
  };
}

function toApi(payload) {
  const out = { ...payload };
  delete out.id;
  delete out.readingTime; // server-computed
  delete out.viewCount;
  delete out.isDemo;
  delete out.publishedAt;
  delete out.createdAt;
  delete out.updatedAt;

  // Drop empty optional strings
  ["heroImageUrl", "excerpt", "slug", "authorId"].forEach((k) => {
    if (out[k] === "" || out[k] == null) delete out[k];
  });

  // Ensure tags is array
  if (out.tags === "" || out.tags == null) out.tags = [];
  if (typeof out.tags === "string") {
    out.tags = out.tags.split(",").map((t) => t.trim()).filter(Boolean);
  }

  if (out.sortOrder !== undefined) out.sortOrder = Number(out.sortOrder) || 0;
  return out;
}

export const blogApi = {
  async list(params = {}) {
    const q = new URLSearchParams();
    if (params.search) q.set("search", params.search);
    if (params.status) q.set("status", params.status);
    if (params.featuredOnly) q.set("featuredOnly", "true");
    if (params.tag) q.set("tag", params.tag);
    if (params.page) q.set("page", String(params.page));
    if (params.pageSize) q.set("pageSize", String(params.pageSize));

    const res = await api.get(`${BASE}?${q.toString()}`);
    return { ...res, items: (res.items || []).map(toUi) };
  },

  async get(idOrSlug) {
    const res = await api.get(`${BASE}/${idOrSlug}`);
    return toUi(res);
  },

  async create(payload) {
    const res = await api.post(BASE, toApi(payload));
    return toUi(res);
  },

  async update(id, payload) {
    const res = await api.patch(`${BASE}/${id}`, toApi(payload));
    return toUi(res);
  },

  async delete(id) {
    return api.delete(`${BASE}/${id}`);
  },
};

export const BLOG_STATUS_LABEL = {
  draft: "Draft",
  published: "Published",
  archived: "Archived",
};

export const BLOG_STATUS_COLOR = {
  draft: "bg-slate-100 text-slate-700 border-slate-200",
  published: "bg-emerald-100 text-emerald-700 border-emerald-200",
  archived: "bg-amber-100 text-amber-700 border-amber-200",
};
